/**
 *
 * @param {boolean} enabled
 * @returns {{botDetectionSettings: {library: string, timeout: number}}|{}}
 */
const botFilteringSettings = enabled => {
  if (!enabled) return {};
  return {
    botDetectionSettings: {
      library: 'botD',
      timeoutMs: 300,
    },
  };
};

export default botFilteringSettings;
